import React from "react";
import "./index.css";

const ProgressDonut = ({ 
  collected = 0, 
  target = 100000, 
  size = 160, 
  stroke = 16, 
  currency = "₹",
  isComplete = false 
}) => {
  const pct = Math.min(100, target === 0 ? 0 : Math.round((collected / target) * 100));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (pct / 100) * circumference;

  // Use green gradient if complete, otherwise use original gradient
  const gradientId = isComplete ? "pdGradientGreen" : "pdGradient";
  const color1 = isComplete ? "#10b981" : "#ff7a18";
  const color2 = isComplete ? "#059669" : "#af002d";
  const color3 = isComplete ? "#047857" : "#32025a";

  // Format number in Indian style (2,34,567)
  const formatIndianNumber = (num) => {
    return new Intl.NumberFormat("en-IN").format(num);
  };

  return (
    <div className="pd-wrapper" style={{ width: size }}>
      <svg className="pd-svg" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <g transform={`translate(${size/2}, ${size/2})`}>
          {/* background circle */}
          <circle
            r={radius}
            fill="none"
            stroke="var(--pd-bg, rgba(0,0,0,0.08))"
            strokeWidth={stroke}
          />
          {/* progress circle */}
          <circle
            r={radius}
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={`${dash} ${circumference - dash}`}
            style={{ transition: "stroke-dasharray 800ms ease" }}
            transform="rotate(-90)"
          />
          <defs>
            {/* Original gradient */}
            <linearGradient id="pdGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#ff7a18" />
              <stop offset="50%" stopColor="#af002d" />
              <stop offset="100%" stopColor="#32025a" />
            </linearGradient>
            {/* Green gradient for completed phases */}
            <linearGradient id="pdGradientGreen" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor={color1} />
              <stop offset="50%" stopColor={color2} />
              <stop offset="100%" stopColor={color3} />
            </linearGradient>
          </defs>
          {/* center labels */}
          <foreignObject x={-radius} y={-radius} width={radius*2} height={radius*2}>
            <div className="pd-center">
              <div className="pd-percent">{pct}%</div>
              <div className="pd-amount">{currency}{formatIndianNumber(collected)}</div>
              <div className="pd-target">of {currency}{formatIndianNumber(target)}</div>
            </div>
          </foreignObject>
        </g>
      </svg>
    </div>
  );
};

export default ProgressDonut;